import { Capacitor } from '@capacitor/core'
import * as Sentry from '@sentry/react'
import { AxiosResponse } from 'axios'
import { App } from '@capacitor/app'
import { isProdStand, SENTRY_DSN, RELEASE_VERSION } from '~/shared/config/env'

const excludePath = [
  '/assets/',
  '/static/',
  '/media/',
  'customers/me',
  'rental-contracts/my',
]

const excludeContent = [
  'Network Error',
  'Token has expired and can no longer be refreshed',
  'Unauthenticated',
  'This action is unauthorized',
]

const excludeStatusCodes = [422, 401]

const getVersion = async () => {
  const platform = Capacitor.getPlatform()

  if (platform === 'web') return RELEASE_VERSION

  const info = await App.getInfo()

  return info.version
}

export const initSentry = async () => {
  if (!isProdStand || !SENTRY_DSN) return

  const version = await getVersion()

  Sentry.init({
    dsn: SENTRY_DSN,
    release: version,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.extraErrorDataIntegration({ depth: 5 }),
    ],

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    beforeSend: (event, hint) => {
      const originalException = hint?.originalException as {
        response: AxiosResponse | undefined
        message: string
        name: string
      }

      const message = originalException.message
      const name = originalException.name
      if (
        (message && excludeContent.some((msg) => message.includes(msg))) ||
        (name && excludeContent.some((msg) => name.includes(msg)))
      ) {
        return null
      }

      const status = event?.extra?.status
      if (
        status &&
        excludeStatusCodes.some((excludeStatus) => excludeStatus === status)
      ) {
        return null
      }

      const url = originalException?.response?.config?.url as string

      if (url && excludePath.some((path) => url.includes(`${path}`))) {
        return null
      }

      return event
    },
  })
}
